import React from 'react';
import { navigate } from '@reach/router';
import { MapStateToProps, connect, MapDispatchToProps } from 'react-redux';

import { RootState } from 'store/store';
import { IProviderItems, ITags } from 'store/providers/providerTypes';

import messages from './Messages';
import Select from '../Select';
import { getTags } from '../FileManager/ItemsViewer/Survey/SurveyEditor/GeneralQuestion/GeneralQuestionEditor';
import { IOption } from '../Select/Select';
import { appDispatch } from 'store/store';
import { updateSearchInFolderId } from 'store/app/appSlice';
import { NumberOrNull } from 'store/entity/types';

interface IStateToProps {
  searchInFolderId: NumberOrNull;
  items?: IProviderItems['items'];
}

interface IDispatchToProps {
  updateSearchInFolderId: (folderId: number | null) => void;
}

interface IOwnProps {
  tags: ITags;
  providerId: number;
}

type IComponentProps = IOwnProps & IStateToProps & IDispatchToProps;

class TagSearchBox extends React.PureComponent<IComponentProps> {
  searchValue: any = React.createRef();

  handleSetPath = (value: IOption) => {
    let list = value.value.toString();
    let current = this.props.tags.data[Number(value.value)].parentId;
    while (current) {
      list = current + ';' + list;
      current = this.props.tags.data[current].parentId;
    }
    navigate(`/content/${this.props.providerId}/tags/${list}`);
  };

  render() {
    const { searchInFolderId } = this.props;
    if (searchInFolderId && this.searchValue && this.searchValue.current) {
      this.searchValue.current.focus();
    }
    return (
      <React.Fragment>
        <Select
          multiChoice={true}
          options={getTags(this.props.tags?.data || {}, false)}
          values={[]}
          onChangeValues={(values) => {
            this.handleSetPath(values[0]);
          }}
          inputStyle={{ minHeight: 'initial', marginTop: '3px' }}
          placeholder={messages.searchTag}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps: MapStateToProps<IStateToProps, IOwnProps, RootState> = (
  state,
  props
) => {
  const searchInFolderId = state.app.searchInFolder.folderId;
  const items = state.providers.items[Number(props.providerId)].items;

  return { searchInFolderId, items };
};

const mapDispatchToProps: MapDispatchToProps<
  IDispatchToProps,
  IOwnProps
> = () => {
  return {
    updateSearchInFolderId: (folderId: number | null) =>
      appDispatch(updateSearchInFolderId({ folderId })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TagSearchBox);
